exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.combined-pay[data-v-3d5d7ba3]{padding:4.26667vw 6.66667vw 4.26667vw 4.8vw;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden\n}\n.combined-pay .content img[data-v-3d5d7ba3]{width:8.53333vw;height:8.53333vw;border:none;margin-right:2.66667vw\n}\n.combined-pay .content p[data-v-3d5d7ba3]{font-family:PingFang SC;font-size:4vw;font-weight:normal;line-height:4vw;letter-spacing:0px;color:#002A3C\n}\n.combined-pay .combined-pay-arrow[data-v-3d5d7ba3]{border:none;width:4px;height:2.13333vw\n}\n", ""]);

// exports
